import React, { useRef } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import AliceCarousel from "react-alice-carousel"
import Img from "gatsby-image"

const Sevices = graphql`
  query {
    allContentfulServices {
      nodes {
        id
        serviceName
        serviceSlug
        servicePicture {
          fluid {
            srcWebp
            srcSetWebp
            srcSet
            src
            sizes
            base64
            aspectRatio
          }
        }
      }
    }
  }
`

export default () => {
  const ref = useRef()
  const handleOnDragStart = e => e.preventDefault()
  const { allContentfulServices } = useStaticQuery(Sevices)
  return (
    <div className="flex flex-col mt-4 pl-6 md:pl-20 pr-6">
      <div className="w-full flex items-center  my-6">
        <span className="text-3xl font-bold inline-block">
          &mdash; Nos Services
        </span>
        <Link to="/Services" className="ml-auto text-right">
          Toutes nos services
        </Link>
      </div>
      <div className="flex items-center -mx-1 relative">
        <AliceCarousel
          ref={ref}
          buttonsDisabled={true}
          dotsDisabled={true}
          responsive={{
            0: {
              items: 1,
            },
            640: {
              items: 2,
            },
            768: {
              items: 3,
            },
            1024: {
              items: 3,
            },
            1280: {
              items: 4,
            },
          }}
          mouseTrackingEnabled
        >
          {allContentfulServices.nodes.map((item, index) => (
            <div key={index} className="relative mx-1">
              <Link to={`/Services/${item.serviceSlug}`}>
                <Img
                  className="rounded h-40 hover:shadow-md mb-0"
                  fluid={item.servicePicture.fluid}
                />
                <div className="rounded w-full h-full absolute inset-0 hover:bg-orange-400 hover:opacity-50" />
                <span className="pb-3 text-lg text-white absolute text-center w-full inset-x-0 bottom-0">
                  {item.serviceName}
                </span>
              </Link>
            </div>
          ))}
        </AliceCarousel>
        <button
          className="absolute inset-y-0 left-0 outline-none focus:outline-none"
          onClick={() => ref.current.slidePrev()}
        >
          <span className="material-icons text-5xl text-white">
            navigate_before
          </span>
        </button>
        <button
          className="absolute inset-y-0 right-0 outline-none focus:outline-none"
          onClick={() => ref.current.slideNext()}
        >
          <span className="material-icons text-5xl text-white ">
            navigate_next
          </span>
        </button>
      </div>
    </div>
  )
}
